module.exports = __webpack_public_path__ + "static/media/defaultItem.0217ed6e.png";